export default "__VITE_ASSET__5B6wbmG$__"